/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-03 11:19:52
 * @FilePath: \frontend\src\utils\validate.js
 */
/**
 * Created by PanJiaChen on 16/11/18.
 */
import { i18n } from '@/Lang/index';

/* eslint no-useless-escape: 0 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
/*
export function validUsername(str) {
  const valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
*/

/*
export function isPositiveInteger(rule, val, callback) {
  var reg = /^[1-9]\d*$/;
  if (!reg.test(val)) {
    callback(new Error(i18n.global.t('validate.positiveIntegerError')));
  } else {
    callback();
  }
}
*/

/*
export function isPositiveIntegerIncludeZero(rule, val, callback) {
  var reg = /^[0-9]\d*$/;
  if (!reg.test(val)) {
    callback(new Error(i18n.global.t('validate.positiveIntegerIncludeZeroError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidEmail(rule, email, callback) {
  var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  if (!reg.test(email)) {
    callback(new Error(i18n.global.t('validate.fromAddressError')));
  } else {
    callback();
  }
}
*/

export function isValidUserEmail(rule, email, callback) {
  var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  if (!reg.test(email)) {
    callback(new Error(i18n.global.t('validate.userEmailAddressError')));
  } else {
    callback();
  }
}

/*
export function isValidPort(rule, port, callback) {
  var reg = /^[1-9]\d*$/;
  if (!reg.test(port) || port > 65535 || port < 1024) {
    callback(new Error(i18n.global.t('validate.portError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidSMPTPort(rule, port, callback) {
  var reg = /^[1-9]\d*$/;
  if (!reg.test(port) || port > 65535 || port < 1) {
    callback(new Error(i18n.global.t('validate.smptPortError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidSmtp(rule, smtp, callback) {
  var reg =
    /^(?=^.{3,255}$)smtp\.?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;

  var reg1 =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (!reg.test(smtp) && !reg1.test(smtp)) {
    callback(new Error(i18n.global.t('validate.smtpServerError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidToAddress(rule, toMails, callback) {
  const toArray = toMails.split(';');
  for (const to_address of toArray) {
    if (!checkEmail(to_address)) {
      callback(new Error(i18n.global.t('validate.toAddressError')));
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidIP(rule, ip, callback) {
  var reg =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (!ip) {
    callback();
  } else {
    if (!reg.test(ip)) {
      if (rule.field === 'mask') {
        callback(new Error(i18n.global.t('validate.maskError')));
      } else if (rule.field === 'ip') {
        callback(new Error(i18n.global.t('validate.ipError')));
      } else if (rule.field === 'gateway') {
        callback(new Error(i18n.global.t('validate.gatewayError')));
      } else if (rule.field === 'dns1') {
        callback(new Error(i18n.global.t('validate.dns1Error')));
      } else if (rule.field === 'dns2') {
        callback(new Error(i18n.global.t('validate.dns2Error')));
      }
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidDNS(rule, dns, callback) {
  var reg = /^(22[0-3]|2[0-1][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$|^$/;
  if (!dns) {
    callback();
  } else {
    if (!reg.test(dns)) {
      if (rule.field === 'dns1') {
        callback(new Error(i18n.global.t('validate.dns1Error')));
      } else if (rule.field === 'dns2') {
        callback(new Error(i18n.global.t('validate.dns2Error')));
      }
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidMask(rule, mask, callback) {
  var reg =
    /^(?:(?:254|252|248|240|224|192|128|0)\.0\.0\.0)|(?:255\.(?:254|252|248|240|224|192|128|0)\.0\.0)|(?:255\.255\.(?:254|252|248|240|224|192|128|0)\.0)|(?:255\.255\.255\.(?:254|252|248|240|224|192|128|0))$/;
  if (!mask) {
    callback();
  } else {
    if (!reg.test(mask)) {
      callback(new Error(i18n.global.t('validate.maskError')));
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidGw(rule, gw, callback) {
  var reg =
    /^(?:(?:(?:25[0-5]|2[0-4][0-9]|(?:1[0-9]{2})|(?:[1-9]?[0-9]))\.){3}(?:25[0-5]|2[0-4][0-9]|(?:1[0-9]{2})|(?:[1-9]?[0-9])))$|^$/;

  if (!gw) {
    callback();
  } else {
    if (!reg.test(gw)) {
      callback(new Error(i18n.global.t('validate.gatewayError')));
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidsubGwIp(rule, ip, callback) {
  var reg =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (!ip) {
    callback();
  } else {
    if (!reg.test(ip)) {
      callback(new Error(i18n.global.t('validate.subGwIpError')));
    } else {
      callback();
    }
  }
}
*/

/*
export function isValidsubGwPort(rule, port, callback) {
  if (isNaN(parseInt(port)) || parseInt(port) < 1024 || parseInt(port) > 65535) {
    callback(new Error(i18n.global.t('validate.portError')));
  } else {
    callback();
  }
}
*/

/*
let apAuth = false;
let stationAuth = false;
export function getStationAuth() {
  return stationAuth;
}

export function getApAuth() {
  return apAuth;
}

export function setApAuth(isOPEN) {
  apAuth = isOPEN;
}

export function setStationAuth(isOPEN) {
  stationAuth = isOPEN;
}
*/

/*
export function isValidSSID(rule, ssid, callback) {
  const reg = /^([a-z0-9A-z\-_]){1,32}$/;
  if (!reg.test(ssid)) {
    callback(new Error(i18n.global.t('validate.ssidError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidFormulaVal(rule, val, callback) {
  const reg = /^[0-9]+(.[0-9]{2})?$/;
  if (!reg.test(val)) {
    callback(new Error(i18n.global.t('validate.formulaVal1MustNum')));
  } else {
    callback();
  }
}
*/

/*
export function isValidApPass(rule, password, callback) {
  const reg = /^([a-z0-9A-Z+\-_=: .?!@#^&*[\](){}|]){8,63}$/;
  if (password === null || password === undefined || password.length < 8 || password.length > 32) {
    callback(new Error(i18n.global.t('validate.passLength')));
  } else if (!reg.test(password) || password.trim().length < 8) {
    callback(new Error(i18n.global.t('validate.apPassError')));
  } else {
    callback();
  }
}
*/

/*
export function isValidStationPass(rule, password, callback) {
  if (password === null || password === undefined || password.length < 8 || password.length > 32) {
    callback(new Error(i18n.global.t('validate.passLength')));
  } else {
    callback();
  }
}
*/

/*
export function isValidNtpServer(rule, ntpServer, callback) {
  const dominReg = /^((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/;
  const ipReg =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (ntpServer === null || ntpServer === undefined) {
    callback(new Error(i18n.global.t('validate.ntpServerError')));
  } else if (!dominReg.test(ntpServer) && !ipReg.test(ntpServer)) {
    callback(new Error(i18n.global.t('validate.ntpServerError')));
  } else {
    callback();
  }
}
*/

export function isChannelError(rule, channel, callback) {
  if (
    !isNaN('0x' + channel) &&
    parseInt(channel, 16) <= parseInt('0x37', 16) &&
    parseInt(channel, 16) >= parseInt('0x28', 16)
  ) {
    callback();
  } else {
    callback(new Error(i18n.global.t('validate.channelError')));
  }
}

export function isPortError(rule, port, callback) {
  if (
    !isNaN('0x' + port) &&
    parseInt(port, 16) <= parseInt('0x137E', 16) &&
    parseInt(port, 16) >= parseInt('0x1010', 16)
  ) {
    callback();
  } else {
    callback(new Error(i18n.global.t('validate.subgPortError')));
  }
}

export function isPanIdError(rule, panId, callback) {
  if (
    !isNaN('0x' + panId) &&
    parseInt(panId, 16) <= parseInt('0xFFFE', 16) &&
    parseInt(panId, 16) >= parseInt('0x0000', 16)
  ) {
    callback();
  } else {
    callback(new Error(i18n.global.t('validate.panIdError')));
  }
}

/*
export function isDeviceIdError(rule, devId, callback) {
  if (isDevIdInRange('0x' + devId)) {
    callback();
  } else {
    callback(new Error(i18n.global.t('validate.devIdError')));
  }
}

function isDevIdInRange(str) {
  // 验证字符串格式是否为 '0x' 开头，后跟 1 到 4 个十六进制数字
  const regex = /^0x[0-9A-Fa-f]{1,12}$/;

  if (!regex.test(str)) {
    return false; // 字符串格式不符合要求，返回 false
  }

  const value = parseInt(str, 16);
  const minValue = 0x000000001000;
  const maxValue = 0xffffffffffef;

  return value >= minValue && value <= maxValue;
}
*/

export function isKeyError(rule, key, callback) {
  const zg = /^[A-Fa-f0-9]*$/;
  if (!zg.test(key)) {
    callback(new Error(i18n.global.t('validate.keyError')));
  } else {
    if (
      parseInt(key, 16) <= parseInt('FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF', 16) &&
      parseInt(key, 16) > parseInt('00000000000000000000000000000000', 16) &&
      key.length === 32
    ) {
      callback();
    } else {
      callback(new Error(i18n.global.t('validate.keyError')));
    }
  }
}

/*
let userPass = '';
export function isValidUserPass(rule, pass, callback) {
  // if (pass.length >= 8 && pass.length <= 32) {
  //   userPass = pass
  //   callback()
  // } else {
  //   callback(new Error(i18n.global.t('validate.passLength')))
  // }
  userPass = pass;
  callback();
}

export function isValidConfirmPass(rule, pass, callback) {
  // if (pass.length >= 8 && pass.length <= 32) {
  //   if (pass === userPass) {
  //     callback()
  //   } else {
  //     callback(new Error(i18n.global.t('validate.passError')))
  //   }
  // } else {
  //   callback(new Error(i18n.global.t('validate.passLength')))
  // }

  if (pass === userPass) {
    callback();
  } else {
    callback(new Error(i18n.global.t('validate.passError')));
  }
}

function checkEmail(email) {
  var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  return reg.test(email);
}
*/

/*
export function isValidNumber(rule, value, callback) {
  if (value < -99999 || value > 99999) {
    callback(new Error(i18n.global.t('validate.isNotValidNumber')));
  } else if (!isNumber(value) || (value + '').indexOf(' ') !== -1 || isNaN(value)) {
    callback(new Error(i18n.global.t('validate.isNaN')));
  } else {
    callback();
  }
}
*/

/*
export function isValidFormulaName(rule, value, callback) {
  if (value.length > 20) {
    callback(new Error(i18n.global.t('validate.nameLen')));
  } else if (isSpace(value)) {
    callback(new Error(i18n.global.t('validate.isSpace')));
  } else {
    callback();
  }
}
*/

export function isAreaNameError(rule, value, callback) {
  if (!value || isSpace(value)) {
    callback(new Error(i18n.global.t('validate.areaNameEmpty')));
  } else if (value.length > 20) {
    callback(new Error(i18n.global.t('validate.areaNameLenError')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else {
    callback();
  }
}

export function isGWNameError(rule, value, callback) {
  if (isSpace(value)) {
    callback(new Error(i18n.global.t('validate.gwNameSpace')));
  } else if (value && value.length > 20) {
    callback(new Error(i18n.global.t('validate.gwNameLenError')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else {
    callback();
  }
}

export function isDashboardNameError(rule, value, callback) {
  if (!value || isSpace(value)) {
    callback(new Error(i18n.global.t('validate.dashboardNameEmpty')));
  } else if (value.length > 20) {
    callback(new Error(i18n.global.t('validate.dashboardNameLenError')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else {
    callback();
  }
}

export function isSerialNoError(rule, value, callback) {
  if (!value) {
    callback(new Error(i18n.global.t('validate.serialNoEmpty')));
  } else if (isSpace(value)) {
    callback(new Error(i18n.global.t('validate.serialNoSpace')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else if (value.length !== 12) {
    callback(new Error(i18n.global.t('validate.serialNoLenError')));
  } else {
    callback();
  }
}

export function isSerialNoCheck(value) {
  if (typeof value !== 'string' || value.trim() === '') {
    return false;
  }

  const parts = value.split(',');
  if (parts.length !== 1) {
    return false;
  }

  const serialNo = parts[0];
  return serialNo.length === 12;
}

export function isGroupError(rule, value, callback) {
  if (isSpace(value)) {
    callback(new Error(i18n.global.t('validate.groupSpace')));
  } else if (value.length > 20) {
    callback(new Error(i18n.global.t('validate.groupLenError')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else {
    callback();
  }
}

export function isEscape(input) {
  //TODO
  const regex = /^[a-zA-Z0-9０-９ａ-ｚＡ-Ｚぁ-んァ-ン一-龥ー～・;:\-~_@*+.,\x20\u3000]*$/;
  if (!regex.test(input)) {
    return true;
  }
  return false;
}

/*
function isNumber(input) {
  const regex = /^-?\d+(\.\d+)?$/;
  if (!regex.test(input)) {
    return false;
  }
  return true;
}
*/

export function isSpace(input) {
  const regex = /^\s+$/g;
  if (!regex.test(input)) {
    return false;
  }
  return true;
}

/**
 * ウィジェット名のバリデーション
 * @param {Object} rule - バリデーションルール
 * @param {string} value - 入力値
 * @param {Function} callback - コールバック関数
 */
export function isWidgetNameError(rule, value, callback) {
  if (!value || isSpace(value)) {
    callback(new Error(i18n.global.t('validate.widgetNameEmpty')));
  } else if (value.length > 20) {
    callback(new Error(i18n.global.t('validate.widgetNameLenError')));
  } else if (isEscape(value)) {
    callback(new Error(i18n.global.t('validate.isEscape')));
  } else {
    callback();
  }
}
